import { renderMessageBarActions_unstable } from '@fluentui/react-message-bar';

/**
 * Renders the final JSX of the MessageBarActions component, given the state and context values.
 */
export const renderMessageBarActions = renderMessageBarActions_unstable;
